<template>
    <div class="user-picker">
        <ilabel :label="label"/>
        <div class="users">
        	<div class="user-avatar">
        		
        	</div>
        	<div class="user-plus">
        		<div class="fal fa-plus"></div>
        	</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: String
    },
    name: 'user-picker',

    data() {
        return {

        }
    }
}
</script>
<style lang="css" scoped>
.user-plus{
	border:2px dashed lightgrey;
	text-align: center;
	padding-top:25px;
	transition: 0.3s all ease;
}
.user-avatar,.user-plus{
	border-radius: 100%;
	width:72px;
	height:72px;
	display: inline-block;
	vertical-align: top;
	margin:0 8px 0 0;

}
.user-plus:hover{
	cursor: pointer;
	background: whitesmoke;
}

.user-avatar{
	border:1px solid lightgrey;
	background-position: center;
	background-size: cover;
}

.users{
	margin-bottom: 8px;
}
</style>